const Plus = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.95625 15V8.76H0.71625V6.52H6.95625V0.279999H9.19625V6.52H15.4363V8.76H9.19625V15H6.95625Z"
              fill="#181818"/>
    </svg>
)

export default Plus
